var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card mb20",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.tabList, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { name: item.value, label: item.title },
              })
            }),
            1
          ),
          _vm.currentTab === "1"
            ? _c(
                "div",
                [
                  _c("FromList", {
                    attrs: { configObj: _vm.philosophyConfig },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:pc:shopping:philosophy:save"],
                          expression:
                            "['platform:pc:shopping:philosophy:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.handlePhilosophySave },
                    },
                    [_vm._v(_vm._s(_vm.loadingBtn ? "提交中 ..." : "保存"))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTab === "3"
            ? _c(
                "div",
                [
                  _c("FromList", {
                    attrs: { configObj: _vm.shoppingQuickEntryConfig },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:pc:shopping:quick:entry:save"],
                          expression:
                            "['platform:pc:shopping:quick:entry:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.handleShoppingQuickEntrySave },
                    },
                    [_vm._v(_vm._s(_vm.loadingBtn ? "提交中 ..." : "保存"))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTab === "4"
            ? _c(
                "div",
                [
                  _c("FromList", {
                    attrs: { configObj: _vm.bottomQrcodeConfig },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:pc:shopping:bottom:qrcode:save"],
                          expression:
                            "['platform:pc:shopping:bottom:qrcode:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.handleBottomQrcodeSave },
                    },
                    [_vm._v(_vm._s(_vm.loadingBtn ? "提交中 ..." : "保存"))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTab === "5"
            ? _c(
                "div",
                [
                  _c("FromList", {
                    attrs: { configObj: _vm.friendlyLinkConfig },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:pc:shopping:friendly:link:save"],
                          expression:
                            "['platform:pc:shopping:friendly:link:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.handleFriendlySave },
                    },
                    [_vm._v(_vm._s(_vm.loadingBtn ? "提交中 ..." : "保存"))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }